import type { UseMutationOptions } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { apiRequest, type ApiError, useApiMutation } from "@/shared/api";
import type {
  RetryKycRequest,
  RetryKycResponse,
} from "../interfaces/kyc.interface";

const retryKycRequest = (payload: RetryKycRequest) => ({
  url: "/profile/kyc/retry",
  method: "post" as const,
  data: payload,
});

export const retryKyc = (payload: RetryKycRequest) =>
  apiRequest<RetryKycResponse>(retryKycRequest(payload));

export const useRetryKyc = (
  options?: UseMutationOptions<RetryKycResponse, ApiError, RetryKycRequest>
) => {
  const queryClient = useQueryClient();

  return useApiMutation<RetryKycResponse, RetryKycRequest>(retryKycRequest, {
    ...options,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
      options?.onSuccess?.(data, variables, context, mutation);
    },
  });
};
